// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			//scrollDownAction(60, 'scroll'); //function change logo on scroll
		})
	};

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_first_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_last_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allFields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allFields.length; j++){
            
            if(allFields[j].getElementsByTagName('input').length > 0){
                if(allFields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allFields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allFields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allFields[j].getElementsByTagName('select').length > 0){
                allFields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allFields[j].getElementsByTagName('textarea').length > 0){
                allFields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	let scrollButtons = document.querySelectorAll('.btn-scroll');

	if(scrollButtons.length > 0){
		scrollButtons.forEach((button)=>{
			button.addEventListener('click', (e)=>{
				e.preventDefault();
				let data = button.getAttribute('href').split('#')[1];
				let target = document.getElementById(data);
				let headerHeight = document.querySelector('header').offsetHeight + 55;

				window.scrollTo({
					top: target.offsetTop - headerHeight,
					behavior: 'smooth'
				});
			});
		});
	}

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((form) => {
			form.classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	if(document.getElementById('email-signup')){
		let buttonSingUp = document.querySelector('#email-signup .signup-btn');
		document.querySelector('.email-signup .fields-wrap').insertAdjacentElement('beforeend', buttonSingUp);
	}

	if(document.getElementById('menu-container')){
		let linksMenu = document.querySelectorAll('.privary-navigation__item a');

		const openBtn = document.querySelector('.js-open-menu');
		const closeBtn = document.querySelector('.js-close-menu');
		const menu = document.getElementById('menu-container');		

		function toggleMenu(isOpen) {
			if (isOpen) {
				menu.classList.add('show');
				openBtn.setAttribute('aria-expanded', 'true');
				
				const firstLink = menu.querySelector('a, button');
				// Solo ejecuta el focus si firstLink existe Y shouldFocus es true
				if (firstLink ) {
					setTimeout(() => firstLink.focus(), 100);
				}
			} else {
				menu.classList.remove('show');
				openBtn.setAttribute('aria-expanded', 'false');
				openBtn.focus();
			}
		}

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll('#privary-navigation li:has(.submenu)')
		let prevMenuItem
		menu_Items.forEach((element) => {
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
				<li class="privary-navigation__item primary-nav-js">
					<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
				</li>`

			Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}
			
			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}

		if (openBtn && closeBtn && menu) {
			openBtn.addEventListener('click', (e) => {
				const isKeyboard = e.pointerType === ''; 
				toggleMenu(true, isKeyboard);
			});
			closeBtn.addEventListener('click', () => toggleMenu(false));

			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape' && menu.classList.contains('show')) {
					toggleMenu(false);
				}
			});

			menu.addEventListener('keydown', (e) => {
				if (e.key !== 'Tab') return;

				const focusables = menu.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])');
				const firstElement = focusables[0];
				const lastElement = focusables[focusables.length - 1];

				if (e.shiftKey) {
					if (document.activeElement === firstElement) {
						e.preventDefault();
						lastElement.focus();
					}
				} else {
					if (document.activeElement === lastElement) {
						e.preventDefault();
						firstElement.focus();
					}
				}
			});
		}
	}

	if(!document.getElementById('home')){
		document.getElementById('header').classList.add('secondary-style');
	}

	const customLbxAlt = new LBX(".lbx-alternative");
	customLbxAlt.customClass = 'close-alt';

	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('open');
				});
				itemHead.parentNode.classList.toggle('open');
			});
		});
	});

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}